/**
 * Runtime API configuration.
 * In deployed environments (non-localhost), uses relative URLs so API calls
 * go to the same domain the frontend is served from.
 * In local development, uses REACT_APP_BACKEND_URL from .env.
 */
function getApiBaseUrl() {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
    if (!isLocal) {
      // Deployed environment: use same origin (relative URLs)
      return window.location.origin;
    }
  }
  // Local development: use env var
  return process.env.REACT_APP_BACKEND_URL || '';
}

export const API_BASE_URL = getApiBaseUrl();
